// assets
import { IconSettings, IconRefresh, IconList, IconServer, IconBolt, IconPhone } from '@tabler/icons-react';

const icons = {
  IconSettings,
  IconRefresh,
  IconList,
  IconServer,
  IconBolt,
  IconPhone
};

// ==============================|| MENU ITEMS - SERVICES ||============================== //

const services = {
  id: 'services',
  title: 'Services',
  type: 'group',
  children: [
    {
      id: 'polling',
      title: 'Polling',
      type: 'item',
      url: '/services/polling',
      icon: icons.IconRefresh
    },
    {
      id: 'automation',
      title: 'Automation',
      type: 'item',
      url: '/services/automation',
      icon: icons.IconBolt
    },
    {
      id: 'workorder_lists',
      title: 'Work Order Lists',
      type: 'item',
      url: '/services/workorder_lists',
      icon: icons.IconList
    },
    {
      id: 'counter_presets',
      title: 'Counter Offer Presets',
      type: 'item',
      url: '/services/counter_presets',
      icon: icons.IconSettings
    },
    {
      id: 'quickbooks',
      title: 'QuickBooks Online',
      type: 'item',
      url: '/services/quickbooks',
      icon: icons.IconSettings
    },
    {
      id: 'quickbooks_payments',
      title: 'QuickBooks Payments',
      type: 'item',
      url: '/services/quickbooks-payments',
      icon: icons.IconList
    },
    {
      id: 'contact_directory',
      title: 'Contact Directory',
      type: 'item',
      url: '/services/contact_directory',
      icon: icons.IconPhone
    },
    {
      id: 'node_management',
      title: 'Node Management',
      type: 'item',
      url: '/services/node',
      icon: icons.IconServer
    },
    {
      id: 'profitability_costs',
      title: 'Business Ledger',
      type: 'item',
      url: '/insights/costs',
      icon: icons.IconSettings
    }
  ]
};

export default services;
